export default __webpack_public_path__ + "static/media/milestone 77 badge.559070b1.svg";